export const SET_SC_TEAM_LOADING = 'SET_SC_TEAM_LOADING'
export const SET_SC_TEAM = 'SET_SC_TEAM'